import { useEffect, useState } from "react";
import { Grid, Box, Typography, IconButton } from "@mui/material";

import SessionTitle from "./SessionTitle";
import MenuItem from "./MenuItem";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function SideBar(props) {
  let [selectedLayout, setSelectedLayout] = useState(0);
  let [selectedContainerType, setSelectedContainerType] = useState(0);
  let [groupedLayouts, setGroupedLayouts] = useState(null);

  const containerTypeEDI = 1;
  const containerTypeCSV = 2;
  const containerTypeOFX = 3;

  useEffect(() => {
    setGroupedLayouts(props.groupedLayouts);
  }, [props.groupedLayouts]);

  const handleClickItemEDI = async (id, layout) => {
    props.handleClickMenuItem(containerTypeEDI, id, layout);
    setSelectedContainerType(containerTypeEDI);
    setSelectedLayout(id);
  };

  const handleClickItemCSV = async () => {
    props.handleClickMenuItem(containerTypeCSV, 0);
    setSelectedContainerType(containerTypeCSV);
    setSelectedLayout(0);
  };

  const handleClickItemOFX = async () => {
    props.handleClickMenuItem(containerTypeOFX, 1);
    setSelectedContainerType(containerTypeOFX);
    setSelectedLayout(1);
  };

  let handleToggleCollection = async (groupName) => {
    let closed = localStorage.getItem("gn_" + groupName + "_closed") === "true";
    let cnId = document.getElementById("cnId_" + groupName);
    let el = document.getElementById("el_" + groupName);
    let em = document.getElementById("em_" + groupName);

    if (closed) {
      localStorage.setItem("gn_" + groupName + "_closed", false);
      cnId.style.display = "block";
      el.style.display = "block";
      em.style.display = "none";
    } else {
      localStorage.setItem("gn_" + groupName + "_closed", true);
      cnId.style.display = "none";
      el.style.display = "none";
      em.style.display = "block";
    }
  };

  let darkMode = localStorage.getItem("darkMode") === "true" ? true : false;

  return (
    <div
      variant="permanent"
      style={{
        minHeight: "100%",

        width: 240,
        borderRight: "solid 1px " + (darkMode ? "#252525" : "#354d6b26"),
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: 240,
          boxSizing: "border-box",
        },
      }}
    >
      <Box
        mt={4.9}
        sx={{
          overflow: "auto",
          bgcolor: "background.default",
          color: "text.primary",
          maxHeight: "calc(100% - 39px)",
        }}
      >
        <Grid container>
          <SessionTitle title="ARQUIVOS EDI" /*trad:*/ />
          {groupedLayouts && groupedLayouts.length === 0 && (
            <>
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "text.secondary",
                    userSelect: "none",
                    textAlign: "center",
                    display: "block",
                    mt: 2,
                    mb: 2,
                  }}
                >
                  Nenhum layout EDI cadastrado
                </Typography>
              </Box>
            </>
          )}
          {groupedLayouts &&
            groupedLayouts.map((group) => {
              let cnClosed =
                localStorage.getItem("gn_" + group.group_name + "_closed") ===
                "true";
              return (
                <>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      color: "#696969",
                      userSelect: "none",
                      borderBottom: "dashed 1px #c8c8c85c",
                      background: "#6767670f",
                      color: "text.primary",
                    }}
                    onClick={() => handleToggleCollection(group.group_name)}
                  >
                    <Box m={1}>
                      <Typography variant="body2">
                        {
                          group.group_name.replace(
                            "__dg_",
                            "Layouts Sem Grupo",
                          ) /*trad:*/
                        }
                        <IconButton
                          sx={{ float: "right", marginTop: "-4px" }}
                          size="small"
                        >
                          <ExpandMoreIcon
                            fontSize="inherit"
                            id={"em_" + group.group_name}
                            style={{
                              display: cnClosed ? "block" : "none",
                            }}
                          />

                          <ExpandLessIcon
                            fontSize="inherit"
                            id={"el_" + group.group_name}
                            style={{
                              display: cnClosed ? "none" : "block",
                            }}
                          />
                        </IconButton>
                      </Typography>
                    </Box>
                  </Grid>
                  <div
                    id={"cnId_" + group.group_name}
                    style={{
                      display: cnClosed ? "none" : "block",
                      width: "100%",
                    }}
                  >
                    {group.layouts &&
                      group.layouts.map((item = [item][0]) => {
                        try {
                          return (
                            <>
                              <Box
                                onClick={(e) =>
                                  handleClickItemEDI(item.id, item.content)
                                }
                                sx={{ width: "100%" }}
                              >
                                <MenuItem
                                  key={containerTypeEDI + "-" + item.id}
                                  itemId={containerTypeEDI + "-" + item.id}
                                  selectedItemId={
                                    selectedContainerType + "-" + selectedLayout
                                  }
                                  icon={item.icon}
                                  name={item.name}
                                />
                              </Box>
                            </>
                          );
                        } catch (e) {
                          return (
                            item["group_name"] === group.group_name && (
                              <Grid item xs={12}>
                                <Box m={1}>
                                  <Typography variant="body2">err</Typography>
                                </Box>
                              </Grid>
                            )
                          );
                        }
                      })}
                  </div>
                  <Box m={1}></Box>
                </>
              );
            })}
          <SessionTitle title={"Outros Arquivos" /*trad:*/} />
          <Box onClick={(e) => handleClickItemOFX()} sx={{ width: "100%" }}>
            <MenuItem
              icon={"./img/di-ofx.png"}
              name={"Arquivo OFX" /*trad:*/}
              itemId={containerTypeOFX}
              selectedItemId={selectedContainerType}
            />
          </Box>
          <Box onClick={(e) => handleClickItemCSV()} sx={{ width: "100%" }}>
            <MenuItem
              icon={"./img/di-csv.png"}
              name={"Arquivo CSV" /*trad:*/}
              itemId={containerTypeCSV}
              selectedItemId={selectedContainerType}
            />
          </Box>
        </Grid>
      </Box>
    </div>
  );
}
